import React from 'react'
import { useParams, Link, Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { LiaGreaterThanSolid } from 'react-icons/lia'
import Header from '../Header/header'
import Whatsapp from '../Whatsapp/Whatsapp'
import blogData from './blogData'
import './BlogPost.css'

const BlogPost = () => {
  const { slug } = useParams()
  const post = blogData.find((p) => p.slug === slug)

  if (!post) {
    return <Navigate to='/blog' replace />
  }

  const relatedPosts = blogData.filter((p) => p.slug !== post.slug).slice(0, 3)

  return (
    <div>
      <Header />
      <Whatsapp />
      <Helmet>
        <title>{post.title} – Sharva Clinique</title>
        <meta name='description' content={post.metaDescription} />
      </Helmet>

      <div className='blogpost_banner'>
        <div className='blogpost_crumb'>
          <Link to='/'>Home</Link> <LiaGreaterThanSolid /> <Link to='/blog'>Blog</Link> <LiaGreaterThanSolid /> {post.category}
        </div>
        <h1>{post.title}</h1>
      </div>

      <div className='blogpost_content'>
        <div className='blogpost_hero_img'>
          <img src={post.image} alt={post.title} />
        </div>

        {post.sections.map((section, idx) => (
          <div className='blogpost_section' key={idx}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((para, pIdx) => (
              <p key={pIdx}>{para}</p>
            ))}
          </div>
        ))}

        <div className='blogpost_cta'>
          <p>
            Considering <Link to={post.serviceLink}>{post.serviceLinkLabel}</Link>? Book a consultation with our specialists at Sharva Clinique and
            get a treatment plan tailored to your skin or hair concern.
          </p>
          <Link to='/appoint' className='blogpost_cta_btn'>
            Book an Appointment
          </Link>
        </div>

        {post.faqs && post.faqs.length > 0 && (
          <div className='blogpost_faqs'>
            <h2>Frequently Asked Questions</h2>
            {post.faqs.map((faq, idx) => (
              <div className='blogpost_faq_item' key={idx}>
                <h3>{faq.q}</h3>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        )}

        <div className='blogpost_related'>
          <h2>Related Blogs</h2>
          <div className='blogpost_related_list'>
            {relatedPosts.map((rp) => (
              <Link to={`/blog/${rp.slug}`} className='blogpost_related_card' key={rp.slug}>
                <img src={rp.image} alt={rp.title} />
                <span>{rp.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlogPost
